import { TParsedConstellationSwaggerMicroservices, TParsers } from '../types'

const MicroservicesParser: TParsers['microservices'] = (
  swaggerfiles,
  _options = {},
) => {
  return Object.keys(swaggerfiles.paths) //
    .reduce<TParsedConstellationSwaggerMicroservices>((acc, pathKey) => {
      if (pathKey.indexOf('{id}') <= 0) return acc

      const pathKeyArray = pathKey.split('/')
      const idx = pathKeyArray.findIndex(elem => elem === '{id}')

      if (idx !== pathKeyArray.length - 1) return acc

      const microserviceName = pathKeyArray[1]
      const event = pathKeyArray[pathKeyArray.length - 2]

      const events = (acc[microserviceName] ??= [])
      events.push(event)

      return acc
    }, {})
}

export default MicroservicesParser
